<template>
  <span v-if="workingReward">
    <v-row class="mt-8">
      <v-col cols="12">
        <v-select label="Balance Type" outlined dense :items="Object.entries(BalanceTypes)" v-model="workingReward.balanceType" item-text="1"
          item-value="0" :rules="requiredRule" @change="onChange" ref="balanceType"/>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-select label="Calculation Method" outlined dense :items="Object.entries(MinBalanceCalculationMethods)" v-model="workingReward.calculationMethod"
          item-text="1" item-value="0" :rules="requiredRule" @change="onChange" ref="calculationMethod"/>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-text-field
          label="Minimum Balance"
          v-model="workingReward.minimumBalanceAmount"
          type="number"
          hint="Ex. 5.00"
          prefix="$"
          hide-spin-buttons
          dense
          :rules="requiredAndPositiveRule"
          @input="onChange"
          name="minimumBalanceAmount"
        />
      </v-col>
    </v-row>

    <v-row class="mt-6">
      <v-col cols= 12>
        <v-text-field
          label="Minimum Balance Reduction Amount"
          v-model="workingReward.minimumBalanceFeeReductionAmount"
          type="number"
          hint="Ex. 5.00"
          prefix="$"
          hide-spin-buttons
          dense
          :rules="requiredAndPositiveRule"
          @input="onChange"
          name="minimumBalanceFeeReductionAmount"
        />
      </v-col>
    </v-row>
  </span>
</template>

<script lang="ts">
import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { MinimumBalanceFeeReductionReward } from '@/api/product/levelrewards/rewards';
import { BalanceTypes, MinBalanceCalculationMethods } from '@/api/product/levelrewards';
import { ValidationTool } from '@/util';

@Component
export default class MinimumBalanceFeeReductionRewardEditor extends Vue {
  @Prop()
  value!:MinimumBalanceFeeReductionReward;

  workingReward:MinimumBalanceFeeReductionReward | null = null;

  // Make available to template
  BalanceTypes:any = BalanceTypes;

  MinBalanceCalculationMethods:any = MinBalanceCalculationMethods;

  requiredRule:Array<any> = [(value: any) => {
    if (value === null || value === undefined || (Array.isArray(value) && value.length === 0)) {
      return 'Required';
    }
    return true;
  }];

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  mounted() {
    this.initialize();
  }

  @Watch('value')
  initialize() {
    this.workingReward = this.value.clone() as MinimumBalanceFeeReductionReward;
  }

  onChange() {
    this.$emit('input', this.workingReward);
  }
}
</script>

<style lang="scss" scoped>
</style>
